module.exports = __webpack_public_path__ + "img/reveal-deal-unlock-blue-black-gif.08541e5d.gif";